module.exports = __webpack_public_path__ + "assets/img/d75489f9dc9a4918c214531e186cfe0d.png";